import React, { useState } from "react";
import { Card, CardContent, Typography, Tooltip, Box } from "@mui/material";
import {
  Phone as PhoneIcon,
  Public as PublicIcon,
  LocationOn as LocationOnIcon,
} from "@mui/icons-material";
import defaultMosques from "../../assets/defaultMosque.json";

const MosqueCard = ({ mosque, countryId }) => {
  const [showFullLocation, setShowFullLocation] = useState(false);
  const [image] = useState(() => {
    const randomIndex = Math.floor(Math.random() * defaultMosques.length);
    return defaultMosques[randomIndex];
  });

  return (
    <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <Box sx={{ position: "relative", height: 0, paddingTop: "60%" }}>
        <Box
          component="img"
          src={image}
          alt={mosque.name}
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            background: "linear-gradient(to top, rgba(0,0,0,0.7), transparent)",
            color: "white",
            p: 1,
          }}
        >
          <Typography variant="h6" sx={{ fontFamily: "Poppins, sans-serif" }}>
            {mosque.name}
          </Typography>
        </Box>
      </Box>
      <CardContent sx={{ flexGrow: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <LocationOnIcon sx={{ mr: 1 }} />
          <Typography
            variant="body2"
            sx={{ fontFamily: "Poppins, sans-serif" }}
          >
            {showFullLocation || mosque.location.length <= 40
              ? mosque.location
              : `${mosque.location.slice(0, 40)}...`}
            {mosque.location.length > 40 && !showFullLocation && (
              <Box
                component="span"
                sx={{
                  fontWeight: "bold",
                  color: "primary.main",
                  cursor: "pointer",
                  ml: 0.5,
                }}
                onClick={() => setShowFullLocation(true)}
              >
                See more
              </Box>
            )}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="body2"
            sx={{ fontFamily: "Poppins, sans-serif" }}
          >
            {mosque.prefecture} • {countryId}
          </Typography>
          <Box sx={{ display: "flex", gap: 1 }}>
            {mosque.contact && (
              <Tooltip title={mosque.contact}>
                <PhoneIcon sx={{ cursor: "pointer" }} />
              </Tooltip>
            )}
            {mosque.officialPageLink && (
              <Tooltip title="Official website">
                <a
                  href={mosque.officialPageLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <PublicIcon sx={{ cursor: "pointer" }} />
                </a>
              </Tooltip>
            )}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default MosqueCard;
